import React, { useEffect, useState } from "react";
import { Documents } from "../constants/ListDokumen";
import DataTable from "react-data-table-component";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import useAxios from "../../../Utils/useAxios";
import { useThemeContext } from "../../../Context/ThemeContext";
import ModalUploadDokumen from "../components/ModalUploadDokumen";
import CreateButton from "../../../CommonElements/Button/CreateButton";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import DaftarColumns from "../constants/DaftarColumns";
import getSKDokumen from "../services/getSKDokumenList";

const SKDokumenContain = () => {
  const axiosInstance = useAxios();
  const [filterText, setFilterText] = useState("");
  const [SKDokumen, setSKDokumen] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [modalUploadDokumenOpen, setModalUploadDokumenOpen] = useState(false);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    getSKDokumenList();
  }, []);

  const getSKDokumenList = async () => {
    setSKDokumen([]);
    const response = await axiosInstance.get("skdokumen/");
    const skdokumen = [
      ...response.data,
      ...Documents.map((item, index) => ({ ...item, id: `Dokumen ${index}` })),
    ];
    setSKDokumen(skdokumen);
  };

  const handleDownloadDokumen = async (e, dokumen, judul) => {
    e.preventDefault();
    getSKDokumen(axiosInstance, dokumen, judul);
  };

  const toggleModalUploadDokumen = () =>
    setModalUploadDokumenOpen(!modalUploadDokumenOpen);

  const filterDokumen = (items) => {
    const filteredItems = items.filter(filterSearch(["judul"], filterText));
    return filteredItems;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <FeatureContainer
      title={"SK Dokumen"}
      createButton={
        <CreateButton toggle={toggleModalUploadDokumen}>
          Upload Dokumen
        </CreateButton>
      }
    >
      <DataTable
        columns={DaftarColumns(themeContext, handleDownloadDokumen)}
        data={filterDokumen(SKDokumen)}
        highlightOnHover
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        theme={themeContext}
      />
      <ModalUploadDokumen
        getSKDokumen={getSKDokumenList}
        modal={modalUploadDokumenOpen}
        toggle={toggleModalUploadDokumen}
      />
    </FeatureContainer>
  );
};
export default SKDokumenContain;
